import PropTypes from "prop-types";
import CircleIIcon from "../../../../assets/circle_i.svg";
import { Select } from "antd";
import { Input } from "@vds/inputs";
import { IsRequiredValidation } from "../formValidation";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../../store/actions/deviceProfile";
import ATSToolTip from "../../../../global/components/ATSToolTip";
import { useEffect, useRef, useState } from "react";

function ExistingLocationFormGroup(props) {
  const { stateSelectorIndex } = props;
  const [isInView, setIsInView] = useState({
    pointName: false,
    trigger: false,
    alertgroup: false,
  });
  const pointNameSelectRef = useRef(null);
  const triggerAlertSelectRef = useRef(null);
  const alertGroupSelectRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView((prev) => {
          const keys = Object.entries(prev)
            .filter((isInView) => isInView[1])
            .map((isInView) => isInView[0]);

          if (keys.length > 0) {
            let obj = { ...prev };
            for (const key of keys) {
              obj = {
                ...obj,
                [key]: entry.isIntersecting,
              };
            }
            return obj;
          }
          return prev;
        });
      },
      {
        root: null,
        threshold: 0.1,
      }
    );
    if (pointNameSelectRef.current) {
      observer.observe(pointNameSelectRef.current);
    }
    if (triggerAlertSelectRef.current) {
      observer.observe(triggerAlertSelectRef.current);
    }
    if (alertGroupSelectRef.current) {
      observer.observe(alertGroupSelectRef.current);
    }
    return () => {
      if (pointNameSelectRef.current) {
        observer.unobserve(pointNameSelectRef.current);
      }
      if (triggerAlertSelectRef.current) {
        observer.unobserve(triggerAlertSelectRef.current);
      }
      if (alertGroupSelectRef.current) {
        observer.unobserve(alertGroupSelectRef.current);
      }
    };
  }, []);

  const dispatch = useDispatch();
  const { formFields, alertGroupOptions } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
    alertGroupOptions: state.deviceProfile.ui.form.alertGroups,
  }));
  const locationList = useSelector((state) =>
    state?.location?.data?.locations?.filter((loc) => loc?.createtype !== "inventory_location")?.map((loc) => ({
      key: loc?.id,
      label:
        Array.isArray(loc?.tags) && loc?.tags?.length > 0
          ? loc?.tags[0]?.name
          : loc?.name || "",
      value:
        Array.isArray(loc?.tags) && loc?.tags?.length > 0
          ? loc?.tags[0]?.name
          : loc?.name || "",
      address:
        Array.isArray(loc?.tags) && loc?.tags?.length > 0
          ? loc?.tags[0]?.address
          : loc?.address || "",
      latitude:
        Array.isArray(loc?.tags) && loc?.tags?.length > 0
          ? loc?.tags[0]?.lat_value
          : loc?.lat_value || "",
      longitude:
        Array.isArray(loc?.tags) && loc?.tags?.length > 0
          ? loc?.tags[0]?.long_value
          : loc?.long_value || "",
      radius:
        Array.isArray(loc?.tags) && loc?.tags?.length > 0
          ? loc?.tags[0]?.radius
          : loc?.radius || "",
    }))
  );
  locationList?.sort((a, b) => a.label.localeCompare(b.label));

  const handleFormField = (field, value) => {
    if (field !== "radius") {
      const validator = IsRequiredValidation(field, value);
      let mapBoxTheme = {
        cssText: `
                .Input {
                    height: 43px;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #212529;
                    font-family: system-ui;
                    pointer-events: none;
                }
                .ClearBtn {
                    display: none !important;
                }
            `,
        variables: {
          unit: "14px",
          padding: "0.5em",
          border: "1px solid rgba(111, 113, 113, 1)",
          borderRadius: "4px",
          boxShadow: "none",
        },
      };
      if (field === "address") {
        if (validator.isValid) {
          mapBoxTheme = {
            cssText: `
                  .Input {
                      height: 43px;
                      font-size: 1rem;
                      font-weight: 400;
                      color: #000;
                      background-color: #dcf5e6;
                      font-family: system-ui;
                      pointer-events: none;
                  }
                  .ClearBtn {
                      display: none !important;
                  }
              `,
            variables: {
              unit: "14px",
              padding: "0.5em",
              border: "1px solid rgb(99, 184, 132)",
              borderRadius: "4px",
              boxShadow: "none",
            },
          };
        } else {
          mapBoxTheme = {
            cssText: `
                .Input {
                    height: 43px;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #000;
                    background-color: #ffece0;
                    font-family: system-ui;
                    pointer-events: none;
                }
                .ClearBtn {
                    display: none !important;
                }
            `,
            variables: {
              unit: "14px",
              padding: "0.5em",
              border: "1px solid #ba2626",
              borderRadius: "4px",
              boxShadow: "none",
            },
          };
        }
      }
      dispatch(
        updateUI({
          key: "form",
          value: {
            fields: {
              ...formFields,
              step3: {
                ...formFields.step3,
                locations: formFields.step3.locations.map((location, index) => {
                  if (index === stateSelectorIndex) {
                    return {
                      ...formFields.step3.locations[index],
                      existing: {
                        ...formFields.step3.locations[index]?.existing,
                        [field]: {
                          ...formFields.step3.locations[index][field],
                          ...validator,
                          value,
                          mapBoxTheme,
                        },
                      },
                    };
                  }

                  return location;
                }),
              },
            },
          },
        })
      );
      return;
    }

    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations: formFields.step3.locations.map((location, index) => {
                if (index === stateSelectorIndex) {
                  return {
                    ...formFields.step3.locations[index],
                    existing: {
                      ...formFields.step3.locations[index]?.existing,
                      [field]: {
                        ...formFields.step3.locations[index][field],
                        value,
                      },
                    },
                  };
                }

                return location;
              }),
            },
          },
        },
      })
    );
  };

  const handleSelectPointName = (value) => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations: formFields.step3.locations.map((location, index) => {
                if (index === stateSelectorIndex) {
                  const selectLocation = locationList?.filter(
                    (loc) => loc?.value === value
                  );

                  return {
                    ...formFields.step3.locations[index],
                    existing: {
                      ...formFields.step3.locations[index]?.existing,
                      pointName: {
                        ...formFields.step3.locations[index]?.pointName,
                        value,
                        class: "",
                      },
                      address: {
                        ...formFields.step3.locations[index]?.address,
                        value:
                          Array.isArray(selectLocation) &&
                          selectLocation?.length > 0
                            ? selectLocation[0]?.address
                            : "",
                        class: "",
                        mapBoxTheme: {
                          cssText: `
                      .Input {
                          height: 43px;
                          font-size: 1rem;
                          font-weight: 400;
                          color: #000;
                          font-family: system-ui;
                          pointer-events: none;
                      }
                      .ClearBtn {
                          display: none !important;
                      }
                  `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        ...formFields.step3.locations[index]?.latitude,
                        value:
                          Array.isArray(selectLocation) &&
                          selectLocation?.length > 0
                            ? selectLocation[0]?.latitude
                            : "",
                        class: "",
                      },
                      longitude: {
                        ...formFields.step3.locations[index]?.longitude,
                        value:
                          Array.isArray(selectLocation) &&
                          selectLocation?.length > 0
                            ? selectLocation[0]?.longitude
                            : "",
                        class: "",
                      },
                      radius: {
                        ...formFields.step3.locations[index]?.radius,
                        value:
                          Array.isArray(selectLocation) &&
                          selectLocation?.length > 0
                            ? selectLocation[0]?.radius
                            : 500,
                      },
                    },
                  };
                }

                return location;
              }),
            },
          },
        },
      })
    );
  };

  return (
    <>
      <div className="py-2 w-100 d-flex justify-content-start align-items-center">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "16px",
          }}
        >
          Select location
        </div>
      </div>
      <div className=" w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-100 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Location point name
          </span>
          <div className="d-relative w-100 pl-2" ref={pointNameSelectRef}>
            <Select
              showSearch
              className={`shipment-form-fields  ${formFields?.step3.locations[stateSelectorIndex]?.existing?.pointName?.class}`}
              key={"[stateSelectorIndex]-point-name"}
              placeholder="Select Location"
              open={isInView.pointName}
              onClick={() => {
                setIsInView((prev) => ({
                  ...prev,
                  pointName: !prev.pointName,
                }));
              }}
              classNames={{
                popup: {
                  root: "ats-popup-select",
                },
              }}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.pointName?.value || "Select Location"
              }
              onChange={(val) => handleSelectPointName(val)}
              style={{ width: "100%", minHeight: "44px !important" }}
              options={
                Array.isArray(locationList) && locationList?.length > 0
                  ? locationList
                  : []
              }
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Location type
          </span>
          <div className="w-100 pe-2">
            <Input
              id={`location-type-${stateSelectorIndex}`} // Add a unique ID for VDS Input
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.existing?.shipping?.class}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.shipping?.value || ""
              }
              onChange={(e) => handleFormField("shipping", e?.target?.value)}
              readOnly={true}
              type="text" // Specify the type as 'text' for general input
            />
          </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Geofence radius(meters){" "}
            <ATSToolTip placement={"topRight"} text="Geofence radius in meters">
              <img src={CircleIIcon} className="mx-1" alt="info" />
            </ATSToolTip>
          </span>
          <div className="w-100 pl-2">
            <Input
              key={"[stateSelectorIndex]-radius"}
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.existing?.radius?.class}`}
              style={{
                height: "44px",
              }}
              min={1}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.radius?.value || ""
              }
              onKeyDown={(e) => {
                if (e.key === ".") {
                  e.preventDefault();
                }
              }}
              onChange={(val) => handleFormField("radius", val)}
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center position-relative">
        <div className="w-100 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Address{" "}
          </span>
          <div className="w-100 pl-2">
            <Input
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.existing?.address?.class}`}
              value={
                formFields?.step3?.locations[stateSelectorIndex]?.existing
                  ?.address?.value
              }
              onChange={(e) =>
                handleFormField("address", e?.target?.value || e)
              }
              id="address"
              name="address"
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center position-relative">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Latitude
          </span>
          <div className="w-100 pe-2">
            <Input
              id={`latitude-${stateSelectorIndex}`} // Unique ID for the input
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.existing?.latitude?.class}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.latitude?.value || ""
              }
              onChange={(e) => handleFormField("latitude", e?.target?.value)}
              required={false}
              readOnly={true}
              type="number" // Assuming latitude will be a number
            />
          </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Longitude
          </span>
          <div className="w-100 pl-2">
            <Input
              id={`longitude-${stateSelectorIndex}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.longitude?.value || ""
              }
              onChange={(e) => handleFormField("longitude", e?.target?.value)}
              type="number"
              required={false}
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex justify-content-start align-items-center">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "16px",
          }}
        >
          Set alert
        </div>
      </div>
      <div className="w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Trigger alerts on
          </span>
          <div className="w-100 pe-2" ref={triggerAlertSelectRef}>
            <Select
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.existing?.trigger?.class}`}
              key={"[stateSelectorIndex]-trigger"}
              placeholder="None"
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.trigger?.value || ""
              }
              open={isInView?.trigger}
              onClick={() => {
                setIsInView((prev) => ({ ...prev, trigger: !prev.trigger }));
              }}
              onChange={(val) => handleFormField("trigger", val)}
              style={{ width: "100%", minHeight: "44px !important" }}
              options={[
                {
                  value: "entry and exit",
                  label: "Both (Entry and exit)",
                },
                {
                  value: "entry only",
                  label: "Entry only",
                },
                {
                  value: "exit only",
                  label: "Exit only",
                },
              ]}
            />
          </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Alert type{" "}
            <ATSToolTip text="Severity level of the alert">
              <img src={CircleIIcon} className="mx-1" alt="info" />
            </ATSToolTip>
          </span>
          <div className="w-100 pl-2">
            <Input
              className={`shipment-form-fields`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.alerttype?.value !== undefined
                  ? formFields?.step3.locations[
                      stateSelectorIndex
                    ]?.existing?.alerttype?.value
                      ?.charAt(0)
                      .toUpperCase() +
                    formFields?.step3.locations[
                      stateSelectorIndex
                    ]?.existing?.alerttype?.value?.slice(1)
                  : "Notification"
              }
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-100 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Alert group{" "}
            <ATSToolTip
              placement={"topLeft"}
              text="Alert groups to be notified of the alert"
            >
              <img src={CircleIIcon} className="mx-1" alt="info" />
            </ATSToolTip>
          </span>
          <div className="w-100 pl-2" ref={alertGroupSelectRef}>
            <Select
              className={`shipment-form-fields-alertGroup`}
              key={"[stateSelectorIndex]-alert-group"}
              placeholder="None"
              open={isInView?.alertgroup}
              onClick={() => {
                setIsInView((prev) => ({
                  ...prev,
                  alertgroup: !prev.alertgroup,
                }));
              }}
              mode="multiple"
              allowClear
              value={
                formFields?.step3.locations[stateSelectorIndex]?.existing
                  ?.alertgroup?.value
              }
              onChange={(val) => handleFormField("alertgroup", val)}
              style={
                formFields?.step3[stateSelectorIndex]?.alertGroup?.value
                  ?.length > 0
                  ? {
                      width: "100%",
                      minHeight: "44px !important",
                    }
                  : {
                      width: "100%",
                      minHeight: "44px !important",
                    }
              }
              options={alertGroupOptions}
            />
          </div>
        </div>
      </div>
    </>
  );
}

ExistingLocationFormGroup.propTypes = {
  stateSelectorIndex: PropTypes.number.isRequired,
};

export default ExistingLocationFormGroup;
